<script lang="ts" module>
  import { Icon, type IconName } from '@/ui/base';
  import BaseBtn from '@/ui/base/BaseBtn.svelte';

  export interface PageLinkProps {
    pageLinkLabel: string;
    onClick?: () => void;
    icon?: IconName;
  }
</script>

<script lang="ts">
  let { icon: iconProp = 'NoteAdd', ...props }: PageLinkProps = $props();
</script>

<BaseBtn
  class="flex w-full gap-2 p-1 hocus:bg-toggle-H"
  onclick={() => {
    props.onClick?.();
  }}
  label={props.pageLinkLabel}
>
  <div class="rounded-sm bg-success p-2">
    <Icon icon={iconProp} class="size-4"></Icon>
  </div>
  <div
    class="grid flex-grow items-center text-left font-sans text-label-sm font-normal text-c-base"
  >
    {props.pageLinkLabel}
  </div>
  <Icon icon="KeyboardArrowRight" class="size-4 h-auto items-center text-c-link"></Icon>
</BaseBtn>
